/**
 * 👤 USERS DATA CLIENT
 *
 * Type-safe user operations following Convex best practices.
 */
import { api } from "@convex/_generated/api";
import { BaseDataClient } from "./baseClient";
/**
 * Users-specific data client
 */
export class UsersClient extends BaseDataClient {
    /**
     * Ensure Clerk user exists in database
     */
    async ensureClerkUser(clerkUser) {
        return await this.client.mutation(api.users.ensureClerkUser, clerkUser);
    }
}
/**
 * Factory function to create a UsersClient
 */
export function createUsersClient(client) {
    return new UsersClient(client);
}
